module.exports = __webpack_public_path__ + "img/hero-background-fireworks.f3d05021.jpeg";